import { emptyFunction } from '@/utils/emptyFunction.util.ts';

import { httpErrorHandler } from './httpErrorHandler.util';

type Return = (error: unknown) => Promise<unknown> | undefined;

export const getErrorResponseInterceptor = (): Return => {
  return async error => {
    await httpErrorHandler(error, emptyFunction);
  };
};
